import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId, OrgTeamTag, OrgTeamTagId } from "@ollie-sports/models";

export async function orgTeamTag__client__getOrgTeamTag(p: { orgTeamTagId: OrgTeamTagId }): Promise<OrgTeamTag | null> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return await h.OrgTeamTag.getDoc(p.orgTeamTagId);
}

// i18n certified - complete
